import { render, staticRenderFns } from "./activitiesVideo2.vue?vue&type=template&id=7388a5dc&scoped=true"
import script from "./activitiesVideo2.vue?vue&type=script&lang=js"
export * from "./activitiesVideo2.vue?vue&type=script&lang=js"
import style0 from "./activitiesVideo2.vue?vue&type=style&index=0&id=7388a5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7388a5dc",
  null
  
)

export default component.exports